module.exports = __webpack_public_path__ + "assets/img/confirm.76a82d8c.png";